import styles from './style.module.scss';
export const Label = ({ props }) => {
    const { title, id } = props;
    return (<div class={styles.label}>
      {id}
      <span>{title ? `(${title})` : ''}</span> :
    </div>);
};
